/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Embed_Captions_Confirm_Job_CountInputs */

const en_embed_captions_confirm_job_count = /** @type {(inputs: Embed_Captions_Confirm_Job_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} separate embed jobs will be submitted, one for each video.`)
};

const fr_embed_captions_confirm_job_count = /** @type {(inputs: Embed_Captions_Confirm_Job_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tâches d'intégration distinctes seront soumises, une par vidéo.`)
};

const de_embed_captions_confirm_job_count = /** @type {(inputs: Embed_Captions_Confirm_Job_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Es werden ${i?.count} separate Einbettungsjobs eingereicht, einer pro Video.`)
};

const it_embed_captions_confirm_job_count = /** @type {(inputs: Embed_Captions_Confirm_Job_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verranno inviati ${i?.count} lavori di incorporamento separati, uno per ogni video.`)
};

const ru_embed_captions_confirm_job_count = /** @type {(inputs: Embed_Captions_Confirm_Job_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Будет отправлено отдельных заданий на встраивание: ${i?.count}, по одному на каждое видео.`)
};

const es_embed_captions_confirm_job_count = /** @type {(inputs: Embed_Captions_Confirm_Job_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se enviarán ${i?.count} trabajos de incrustación independientes, uno por cada video.`)
};

const zh_cn2_embed_captions_confirm_job_count = /** @type {(inputs: Embed_Captions_Confirm_Job_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`将提交 ${i?.count} 个单独的嵌入任务，每个视频一个。`)
};

const ja_embed_captions_confirm_job_count = /** @type {(inputs: Embed_Captions_Confirm_Job_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`動画ごとに1つずつ、${i?.count} 件の個別の埋め込みジョブが送信されます。`)
};

const hi_embed_captions_confirm_job_count = /** @type {(inputs: Embed_Captions_Confirm_Job_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} अलग-अलग एम्बेड जॉब सबमिट किए जाएँगे, प्रत्येक वीडियो के लिए एक।`)
};

const pt_pt2_embed_captions_confirm_job_count = /** @type {(inputs: Embed_Captions_Confirm_Job_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Serão enviados ${i?.count} trabalhos de incorporação separados, um por cada vídeo.`)
};

/**
* | output |
* | --- |
* | "{count} separate embed jobs will be submitted, one for each video." |
*
* @param {Embed_Captions_Confirm_Job_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_confirm_job_count = /** @type {((inputs: Embed_Captions_Confirm_Job_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Confirm_Job_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_confirm_job_count(inputs)
	if (locale === "de") return de_embed_captions_confirm_job_count(inputs)
	if (locale === "it") return it_embed_captions_confirm_job_count(inputs)
	if (locale === "ru") return ru_embed_captions_confirm_job_count(inputs)
	if (locale === "es") return es_embed_captions_confirm_job_count(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_confirm_job_count(inputs)
	if (locale === "ja") return ja_embed_captions_confirm_job_count(inputs)
	if (locale === "hi") return hi_embed_captions_confirm_job_count(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_confirm_job_count(inputs)
	return en_embed_captions_confirm_job_count(inputs)
});